import {
  UpdateDocumentsUploadProcessDocumentsDocument,
  UpdateDocumentsUploadProcessDocumentsMutation,
  UpdateDocumentsUploadProcessDocumentsMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateUploadProcessDocument = () => {
  const [mutate, { loading }] = useMutation(UpdateDocumentsUploadProcessDocumentsDocument, {
    extractorFn: (data: UpdateDocumentsUploadProcessDocumentsMutation) =>
      data.documentsMutations.updateDocumentsUploadProcessDocument,
  })

  const updateUploadProcessDocument = (
    variables: UpdateDocumentsUploadProcessDocumentsMutationVariables
  ) => {
    return mutate({
      variables,
    })
  }

  return { updateUploadProcessDocument, loading }
}
